// 专业uuid
export const MAJOR = {
    STRUCTURE: "a8d30be6f64740caadced1c4f7c82c3a",
    HVAC: "0ba9ba39b9ed4dc895cd071ad300f98d",
}

export function getMajorName(value: string) {
    if (value === MAJOR.STRUCTURE) {
        return "(结构)";
    } else if (value === MAJOR.HVAC) {
        return "(暖通)";
    }
    return "";
}